module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gallery"
  }, [_c('div', {
    ref: "bigImg",
    staticClass: "bigImg",
    on: {
      "mouseover": _vm.sMouseover,
      "mousemove": _vm.sMousemove,
      "mouseout": _vm.sMouseout
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.gallery.bigImg
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "selector"
  }), _vm._v(" "), (_vm.gallery.video !== undefined) ? _c('div', {
    staticClass: "preview-btn"
  }, [_c('span', {
    staticClass: "video-icon",
    on: {
      "click": _vm.playVideo
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.goodsVideo),
      expression: "goodsVideo"
    }],
    staticClass: "video"
  }, [_c('a', {
    staticClass: "close-video",
    attrs: {
      "href": "#none"
    },
    on: {
      "click": _vm.closeVideo
    }
  }), _vm._v(" "), _c('video', {
    ref: "video",
    attrs: {
      "src": _vm.gallery.video,
      "controls": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "smallImg"
  }, _vm._l((_vm.gallery.list), function(item, index) {
    return _c('div', {
      on: {
        "mouseenter": function($event) {
          return _vm.mGallery(index)
        }
      }
    }, [_c('img', {
      class: {
        'active': _vm.gallery.currIndex === index
      },
      attrs: {
        "src": item.small
      }
    })])
  }), 0), _vm._v(" "), _c('div', {
    ref: "bigView",
    staticClass: "big-view"
  }, [_c('img', {
    attrs: {
      "src": _vm.gallery.bigImg
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67d737b8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/goods-godule/module-gallery.vue
// module id = 1624
// module chunks = 1